import { Chip, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { CostFigure } from "./cost-figure"

export function CostFacilityCostRow({ item, currencySymbol, onFacilityClick }) {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            onClick={handleClick}
            data-cy="facility-cost-row"
            sx={{
                py: 0.75,
                px: 0.5,
                borderRadius: 0.5,
                cursor: "pointer",
                "&:hover": { bgcolor: "action.hover" },
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" noWrap sx={{ minWidth: 0, fontSize: "16px" }}>
                    {item.facilityName}
                </Typography>
                <If value={item.assetCount}>
                    <Chip
                        size="small"
                        label={
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                <Iconify icon="proicons:box" sx={{ fontSize: 14 }} />
                                <span>{item.assetCount?.toLocaleString("en-GB")}</span>
                            </Stack>
                        }
                        sx={{
                            height: 22,
                            bgcolor: "#DEF2F4",
                            color: "primary.main",
                            fontWeight: 500,
                            "& .MuiChip-label": { px: 0.75, py: 0 },
                        }}
                    />
                </If>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
                <CostFigure
                    value={item.totalCost || 0}
                    currencySymbol={currencySymbol}
                    fontWeight={700}
                    sx={{ fontSize: "16px" }}
                    dataCy="facility-cost"
                />
                <Iconify icon="mdi:chevron-right" sx={{ fontSize: 18, color: "text.secondary" }} />
            </Stack>
        </Stack>
    )

    function handleClick() {
        if (onFacilityClick) onFacilityClick(item)
    }
}
